const analysis = {
  modalInformation: {
    title: 'Age Classification Description',
    ageClassification: 'Age Classification',
    ageRange: 'Age Range',
    classification1: 'Classification 1',
    ageRange1: '< 35 Years \n 35 - 40 Years \n > 40 Years',
    classification2: 'Classification 2',
    ageRange2: '< 40 Years  \n >= 40 Years',
    classification3: 'Classification 3',
    ageRange3:
      '0 - 10 Years \n 11 - 20 Years \n 21 - 30 Years \n 31 - 40 Years \n 41 - 50 Years \n > 50 Years'
  },
  language: 'Language',
  ageClassification: 'Age Classification',
  resultCategory: 'Result Category',
  client: 'Client',
  name: 'Name',
  userType: 'User Type',
  userTypePlaceholder: 'Select User Type',
  user: 'User',
  location: 'Location',
  department: 'Department',
  modalSelect: {
    selectLanguage: 'Select Language',
    selectResultCategory: 'Select Result Category',
    selectClient: 'Select Client',
    selectUser: 'Select User',
    selectDepartment: 'Select Department',
    selectLocation: 'Select Location',
    columnLanguage: 'Language',
    columnResultCategory: 'Result Category',
    columnClient: 'Client',
    columnUser: 'User',
    columnDepartment: 'Department',
    columnLocation: 'Location'
  },
  modalEditDescription: {
    titleAbnormal: 'Edit Abnormal Description',
    titleNormal: 'Edit Normal Description',
    examinationItem: 'Examination Item',
    examinationDescription: 'Examination Description',
    description: 'Description',
    descriptionDetail: 'Description Detail'
  },
  modalEditResultCategory: {
    title: 'Edit Result Category',
    origin: 'Result Category Origin',
    adjustment: 'Result Category Adjustment',
    selectAdjustment: 'Select Result Category Adjustment'
  },
  modalClearProperties: {
    title: 'Confirm Clear Properties',
    message: 'Are you sure want to clear all properties?'
  },
  modalDelete: {
    title: 'Confirm Delete',
    message: 'Are you sure want to delete {{field}}?'
  },
  formUserEntity: {
    titleAdd: 'Add User Entity',
    titleEdit: 'Edit User Entity',
    title: 'User Entity'
  }
}

export default analysis
